import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-348b931a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-space-people" }
const _hoisted_2 = { class: "user-card-content" }
const _hoisted_3 = { class: "user-card-header" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-comment" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "user-card-body" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "info-lacking"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_13 = {
  href: "/myaccount/info/editprofile",
  target: "_blank",
  title: "Edit your profile"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(in the Thought Leadership and Work Information section).", -1 /* HOISTED */))
const _hoisted_15 = { class: "filters" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, " Any Expertise ", -1 /* HOISTED */))
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 2,
  class: "loading"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1 /* HOISTED */))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 3,
  class: "people-none-found"
}
const _hoisted_23 = {
  key: 4,
  class: "people-stats"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { id: "no-location" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 5,
  class: "people"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonAvatar = _resolveComponent("PersonAvatar")!
  const _component_MapMarker = _resolveComponent("MapMarker")!
  const _component_MarkerCluster = _resolveComponent("MarkerCluster")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_Vue3ToggleButton = _resolveComponent("Vue3ToggleButton")!
  const _component_space_person = _resolveComponent("space-person")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.popUpUser)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "user-card-overlay",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearPopUpUser && _ctx.clearPopUpUser(...args)))
        }, [
          _createElementVNode("div", {
            class: "user-card",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_PersonAvatar, { user: _ctx.popUpUser }, null, 8 /* PROPS */, ["user"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", {
                  class: "user-display-name",
                  innerHTML: _ctx.popUpUser.DisplayName
                }, null, 8 /* PROPS */, _hoisted_4),
                (_ctx.currentUser.UserID != _ctx.popUpUser.UserID)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      id: "thought-send-message",
                      href: "#",
                      class: "btn btn-small",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendMessage(_ctx.popUpUser!.UserID)))
                    }, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.popUpUser.Expertise)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "user-expertise",
                      innerHTML: _ctx.popUpUser.Expertise
                    }, null, 8 /* PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true),
                (_ctx.popUpUser.Vision)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "user-vision",
                      innerHTML: _ctx.popUpUser.Vision
                    }, null, 8 /* PROPS */, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.popUpUser.ProfileURL
                }, "View profile", 8 /* PROPS */, _hoisted_10)
              ])
            ]),
            _createElementVNode("button", {
              class: "no-style user-card-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearPopUpUser && _ctx.clearPopUpUser(...args)))
            }, " × ")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.infoLacking.length > 0 && !_ctx.infoLackingHidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", null, [
            _createTextVNode(" Students searching for your " + _toDisplayString(_ctx.infoLacking.join(' or ')) + " currently won't find you.", 1 /* TEXT */),
            _hoisted_12,
            _createElementVNode("a", _hoisted_13, "Update your " + _toDisplayString(_ctx.infoLacking.join(' and ')), 1 /* TEXT */),
            _createTextVNode(),
            _hoisted_14
          ]),
          _createElementVNode("button", {
            class: "no-style vue-close",
            title: "Hide",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.infoLackingHidden = true;})
          }, " × ")
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filter.name) = $event)),
        type: "text",
        placeholder: "Name",
        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.filter.name]
      ]),
      _createElementVNode("input", {
        ref: "locationFilter",
        type: "text",
        placeholder: _ctx.locationPlaceholder,
        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter.expertise) = $event))
      }, [
        _hoisted_17,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertiseData, (expertise) => {
          return (_openBlock(), _createElementBlock("option", {
            key: expertise,
            value: expertise
          }, _toDisplayString(expertise), 9 /* TEXT, PROPS */, _hoisted_18))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, _ctx.filter.expertise]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-small",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
      }, " Reset All ")
    ]),
    _createVNode(_component_GoogleMap, {
      id: "g-map",
      ref: "mapRef",
      style: {"height":"400px"},
      "api-key": _ctx.apiKey,
      center: _ctx.center,
      zoom: _ctx.zoom,
      "keyboard-shortcuts": false,
      "fullscreen-control": false,
      "street-view-control": false,
      "map-type-control": false,
      styles: _ctx.mapStyle,
      "max-zoom": 9
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MarkerCluster, { options: _ctx.clusterOptions }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsersMarkers, (marker) => {
              return (_openBlock(), _createBlock(_component_MapMarker, {
                key: marker.userId,
                options: _ctx.markerOptionsGenerator(1, marker),
                onClick: ($event: any) => (_ctx.setPopUpUserId(marker.userId))
              }, null, 8 /* PROPS */, ["options", "onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["options"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["api-key", "center", "zoom", "styles"]),
    (!_ctx.googleLoaded || !_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
      : _createCommentVNode("v-if", true),
    (_ctx.dataLoaded && _ctx.listUsers.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("p", null, [
            _createTextVNode("No users found for this search. "),
            _createElementVNode("a", {
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, "Reset filters.")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.dataLoaded && _ctx.listUsers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_ctx.mapDirty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.filteredUsersMarkers.length) + " " + _toDisplayString(_ctx.pluralize('student', _ctx.filteredUsersMarkers.length)) + " in the map area.", 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.listUsers.length) + " " + _toDisplayString(_ctx.pluralize('student', _ctx.listUsers.length)) + " in " + _toDisplayString(_ctx.currentSpace.SpaceName), 1 /* TEXT */)),
          ((_ctx.mapDirty && _ctx.usersWithoutLocation.length > 0))
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, [
                  _createElementVNode("span", null, "Include " + _toDisplayString(_ctx.usersWithoutLocation.length) + " " + _toDisplayString(_ctx.pluralize('student', _ctx.usersWithoutLocation.length)) + " who " + _toDisplayString(_ctx.pluralize('has', _ctx.usersWithoutLocation.length)) + " not provided location details", 1 /* TEXT */),
                  _createVNode(_component_Vue3ToggleButton, {
                    "is-active": _ctx.includeNoLocationUsers,
                    "onUpdate:isActive": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.includeNoLocationUsers) = $event)),
                    "track-active-color": '#0080c6',
                    "track-border-width": '2px',
                    "handle-diameter": '26px',
                    "track-width": '50px',
                    "handle-distance": '20px'
                  }, null, 8 /* PROPS */, ["is-active"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "sort btn-a",
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.sortDirection = !_ctx.sortDirection), ["prevent"]))
          }, [
            (_ctx.sortDirection)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "a-z"))
              : (_openBlock(), _createElementBlock("span", _hoisted_29, "z-a"))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.listUsers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUsers, (user) => {
            return (_openBlock(), _createBlock(_component_space_person, {
              key: user.UserID,
              user: user,
              onClick: ($event: any) => (_ctx.setPopUpUserId(user.UserID)),
              onMapIconClicked: _ctx.centerOnUser
            }, null, 8 /* PROPS */, ["user", "onClick", "onMapIconClicked"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}